import toast from 'Shared/toast';

function copyToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
            .writeText(text)
            .then(() => toast.success('Copied to clipboard!'))
            // eslint-disable-next-line no-console
            .catch((err) => console.error('Failed to copy: ', err));
    } else {
        toast.error('Unable to copy to clipboard!');
    }
}

export default copyToClipboard;
